import { useEffect } from "react";

export function useNoMinWidth() {
    useEffect(() => {
        document.body.classList.add("no-min-width");
    }, []);
}
